import React from 'react';
import { Button, Grid } from '@mui/material';
import { NumberField, TextField } from '../CommonComponents/Form';
import LocationPicker, { LocationType } from '../CommonComponents/GoogleMap/LocationPicker';
import DraggablePositionMap from '../CommonComponents/GoogleMap/DraggablePositionMap';

type PropsType = {
    entity: any,
    onChange: (a: any) => void,
}

export default function TenantLocation({
    entity,
    onChange,
}: PropsType) {
    const [showAllFields, setShowAllFields] = React.useState(false);

    const hasError = React.useMemo(() => (
        entity.lat < -90 || entity.lat > 90
        || entity.lng < -180 || entity.lng > 180
        || (entity.lat && !entity.lng)
        || (!entity.lat && entity.lng)
    ), [entity]);

    return (
        <>
            <Grid container spacing={2} sx={{ mb: 2 }} justifyContent="flex-end">
                <Grid item xs={12} lg>
                    <LocationPicker
                        error={hasError}
                        label="Sök adress"
                        defaultText={
                            [entity.street, entity.zip, entity.city, entity.country]
                                .filter(Boolean).join(', ')
                        }
                        onChange={(location: LocationType | null) => {
                            if (location) {
                                onChange({
                                    lat: location.lat,
                                    lng: location.lng,
                                    street: location.street,
                                    zip: location.zip,
                                    city: location.city,
                                });
                            }
                        }}
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="text"
                        onClick={() => setShowAllFields(!showAllFields)}
                    >
                        {showAllFields ? 'Dölj detaljer' : 'Redigera detaljer'}
                    </Button>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mb: 2, display: showAllFields ? undefined : 'none' }}>
                <Grid item xs={12} lg={6}>
                    <NumberField
                        name="lat"
                        label="Latitud"
                        value={entity.lat}
                        onChange={onChange}
                        minValue={-90}
                        maxValue={90}
                        required={entity.lng != null}
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <NumberField
                        name="lng"
                        label="Longitud"
                        value={entity.lng}
                        onChange={onChange}
                        minValue={-180}
                        maxValue={180}
                        required={entity.lat != null}
                    />
                </Grid>
                <Grid item xs={0} lg={4} />
                <Grid item xs={12}>
                    <TextField
                        name="street"
                        label="Gata"
                        value={entity.street}
                        onChange={onChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="zip"
                        label="Postnummer"
                        value={entity.zip}
                        onChange={onChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="city"
                        label="Stad"
                        value={entity.city}
                        onChange={onChange}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <DraggablePositionMap
                        lat={entity.lat}
                        lng={entity.lng}
                        onChange={(
                            { lat, lng }
                            : { lat: number, lng: number }
                        ) => (
                            onChange({ lat, lng })
                        )}
                        height={350}
                    />
                </Grid>
            </Grid>
        </>
    );
}
